var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C11.5155 12 12.969 11.3679 14.0406 10.2426C15.1122 9.11742 15.7143 7.5913 15.7143 6C15.7143 4.4087 15.1122 2.88258 14.0406 1.75736C12.969 0.632141 11.5155 0 10 0C8.48448 0 7.03103 0.632141 5.95939 1.75736C4.88775 2.88258 4.28571 4.4087 4.28571 6C4.28571 7.5913 4.88775 9.11742 5.95939 10.2426C7.03103 11.3679 8.48448 12 10 12ZM7.95982 14.25C3.5625 14.25 0 17.9906 0 22.6078C0 23.3766 0.59375 24 1.32589 24H18.6741C19.4062 24 20 23.3766 20 22.6078C20 17.9906 16.4375 14.25 12.0402 14.25H7.95982Z",
    fill: "url(#paint0_linear_59_334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_334",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6b380360d93dcdee52d6a2836acdaad3.svg";
export { ForwardRef as ReactComponent };